import i18next from 'i18next';
import { DISTANCE_UNIT } from '../../consts/distance-units';
import { isNumber } from '../utils';

export type DistanceOptions = {
  showUnits?: boolean;
  roundValue?: boolean;
};

export const convertDistanceUnits = (
  value: number,
  units: DISTANCE_UNIT = DISTANCE_UNIT.MI,
  nextUnits: DISTANCE_UNIT = DISTANCE_UNIT.KM,
  { showUnits = false, roundValue = true }: DistanceOptions = {}
): string => {
  
  if (!isNumber(value)) return '';
  
  if (units !== nextUnits) {
    if (nextUnits === DISTANCE_UNIT.MI) value = (value * 0.621371192); // convert km to miles
    else if (nextUnits === DISTANCE_UNIT.KM) value = (value / 0.621371192); // convert miles to km
  }

  const renderValue = roundValue ? value.toFixed(1).replace('.0', '') : value.toFixed(2);

  if (showUnits) return `${renderValue} ${i18next.t(nextUnits)}`;
  return renderValue;
};
